<template>
    <vue-cookie-accept-decline
            :ref="'myPanel1'"
            :elementId="'myPanel1'"
            :debug="false"
            :position="'bottom-left'"
            :type="'floating'"
            :disableDecline="false"
            :transitionName="'slideFromBottom'"
            :showPostponeButton="false"
            @status="cookieStatus"
            @clicked-accept="cookieClickedAccept"
            @clicked-decline="cookieClickedDecline">

        <!-- Optional -->
        <div slot="postponeContent">
            &times;
        </div>

        <!-- Optional -->
        <div slot="message">
          {{ $t('We use cookies to ensure you get the best experience on our website') }}. <router-link to="/cookie-declaration">{{ $t('links.Learn More') }}...</router-link>
        </div>

        <!-- Optional -->
        <div slot="declineContent">
          {{ $t('OPT OUT') }}
        </div>

        <!-- Optional -->
        <div slot="acceptContent">
          {{ $t('GOT IT') }}!
        </div>
    </vue-cookie-accept-decline>
</template>

<script>
    export default {
        name: "CookieAcceptDecline",
        data: () => ({
            status: null
        }),
        methods: {
            cookieStatus (status) {
                this.status = status
            },
            cookieClickedAccept () {
                this.status = 'accept'
                this.$emit('set-status', this.status)
                console.log(this.$router.currentRoute.fullPath)
            },
            cookieClickedDecline () {
                this.status = 'decline'
                this.$emit('set-status', this.status)
            },
            cookieRemovedCookie () {
                this.status = null
                this.$refs.myPanel1.init()
            },
            removeCookie () {
              console.log("remove cookie")
                this.$refs.myPanel1.removeCookie()
                this.$refs.myPanel1.init()
                this.$emit('set-status', this.status)
            }
        },
    }
</script>

<style>
.theme--dark.v-sheet .cookie__floating {
  background-color: var(--v-background-base) !important;
}
.theme--dark.v-sheet .cookie__floating__buttons__button {
  background-color: var(--v-background-base) !important;
}
</style>
